module.exports = __webpack_public_path__ + "static/media/emotions.bed4b2d7.svg";